import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import {
  HAS_CREATE_VIEW_ONE_PERMISSION_OF,
  HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
  HAS_LIST_VIEW_ONE_PERMISSION_OF,
  PERMISSIONS,
} from '@/constants/permissions.ts'

const routePaymentTermsHome: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue') // Lazy load the component
  },
  meta: {
    doctypes: { [DOCTYPES.PAYMENT_TERM]: HAS_LIST_VIEW_ONE_PERMISSION_OF },
  },
  name: 'paymentTerms-home', // Name of the route
  path: '',
}

const routePaymentTermDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/paymentTerms/ViewPaymentTerm.vue')
  },
  meta: {
    detail: { doctype: DOCTYPES.PAYMENT_TERM, perm_type: PERMISSIONS.READ },
    doctypes: { [DOCTYPES.PAYMENT_TERM]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF },
  },
  name: 'paymentTermDetail',
  path: ':id',
}

const routePaymentTermCreate: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/paymentTerms/AddPaymentTerm.vue')
  },
  meta: {
    doctypes: { [DOCTYPES.PAYMENT_TERM]: HAS_CREATE_VIEW_ONE_PERMISSION_OF },
  },
  name: 'new-payment-term',
  path: 'new-payment-term',
}

const routePaymentTermsRoot: RouteRecordRaw = {
  children: [routePaymentTermsHome, routePaymentTermDetail, routePaymentTermCreate],
  path: 'payment-term',
}

export {
  routePaymentTermCreate,
  routePaymentTermDetail,
  routePaymentTermsHome,
  routePaymentTermsRoot,
}
